import { RpcClient, RpcCallback } from './Rpc/RpcClient'
import { InterstitialSettings } from '../interstitials/iframeInterstitial/providers/settings'

export class MerchantRpcClient extends RpcClient {
  // parameters argument can be removed but we have to update the templates.
  public openHostedInterstitial(settings: InterstitialSettings, parameters: any, callback: RpcCallback, openerElement: HTMLElement) {
    function restoreFocus() {
      if (openerElement) {
        openerElement.focus()
      }
    }
    this.call('openHostedInterstitial', [settings], callback, undefined, restoreFocus)
  }

  public refreshPlacements(options?: any, cb?: RpcCallback) {
    this.call('refreshPlacements', [options], cb)
  }
}

export interface MerchantRpcClientFactory {
  (win: Window, targetWindow: Window, namespace: string, targetOrigin: string): MerchantRpcClient
}

export function merchantRpcClientFactory(
  window: Window,
  targetWindow: Window,
  namespace: string,
  targetOrigin: string
): MerchantRpcClient {
  return new MerchantRpcClient(window, targetWindow, namespace, targetOrigin)
}
